import React from 'react';

const LoadingIndicator: React.FC = () => {
  return (
    <div style={styles.overlay}>
      <div style={styles.loader}>
        <div className="spinner"></div>
        <p style={styles.message}>LOADING...</p>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed' as 'fixed',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  loader: {
    textAlign: 'center' as 'center',
    color: '#fff',
    display: 'flex',
    flexDirection: 'column' as 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  message: {
    marginTop: '1rem',
    fontSize: '1.2rem',
  },
};

export default LoadingIndicator;